/**
 * @generated SignedSource<<8449d5dcdbc8d01172c7f9f42c97bbe9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BranchPickerRepositoryBranchRefs$data = {
  readonly defaultBranchRef: {
    readonly " $fragmentSpreads": FragmentRefs<"BranchPickerRef">;
  } | null;
  readonly id: string;
  readonly refs: {
    readonly " $fragmentSpreads": FragmentRefs<"BranchPickerRepositoryBranches">;
  } | null;
  readonly " $fragmentType": "BranchPickerRepositoryBranchRefs";
};
export type BranchPickerRepositoryBranchRefs$key = {
  readonly " $data"?: BranchPickerRepositoryBranchRefs$data;
  readonly " $fragmentSpreads": FragmentRefs<"BranchPickerRepositoryBranchRefs">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "BranchPickerRepositoryBranchRefs"
};

(node as any).hash = "3987830ca22f372a937fcef8c7dd5e8b";

export default node;
